<template>
    <div>
        <Layout>
            <div class="row form__common--center">
                <div class="col-lg-12">
                    <div class="card" style="min-height: 100vh">
                        <template v-if="!isActiveReplyEmail && !isActiveSenderEmail && !isActiveDomainEmail && !isActiveCustomDomainEmail">
                            <div class="card-header">
                                <h3 class="mb-0 title--screen">{{ $t('managerForm.analytics.dataManipulation') }}</h3>
                            </div>
                            <div class="card-body">
                                <div
                                    style="
                                        width: 100%;
                                        border: 1px solid #dbdbdb;
                                        border-radius: 4px;
                                        -webkit-border-radius: 4px;
                                        -moz-border-radius: 4px;
                                        box-shadow: 0px 2px 1px #c9c9c9;
                                        padding: 20px;
                                    "
                                >
                                    <div class="form-group row align-items-center">
                                        <div class="col-sm-2 text-nowrap" style="min-width: 220px">
                                            <button class="btn btn-common btn-outline-success" @click="onOpenSenderEmail" type="button">
                                                {{ $t('managerForm.email.senderEmail') }}
                                            </button>
                                        </div>
                                        <div class="col-sm-9"><span>送信者メールアドレスの「登録・削除」を行います。 </span></div>
                                    </div>
                                    <div class="form-group row align-items-center">
                                        <div class="col-sm-2 text-nowrap" style="min-width: 220px">
                                            <button class="btn btn-common btn-outline-success" @click="onOpenReplyEmail" type="button">
                                                {{ $t('managerForm.email.replyEmail') }}
                                            </button>
                                        </div>
                                        <div class="col-sm-9"><span> 返信先メールアドレスの「登録・削除」を行います。 </span></div>
                                    </div>
                                    <div class="form-group row align-items-center">
                                        <div class="col-sm-2 text-nowrap" style="min-width: 220px">
                                            <button class="btn btn-common btn-outline-success" @click="onOpenDomainEmail" type="button">
                                                {{ $t('managerForm.email.domainEmail') }}
                                            </button>
                                        </div>
                                        <div class="col-sm-9"><span> 送信ドメイン認証設定（DKIM/SPF/DMARC） </span></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <ReplyEmail v-if="isActiveReplyEmail" />
                        <SenderEmail v-if="isActiveSenderEmail" />
                        <DomainEmail v-if="isActiveDomainEmail" />
                    </div>
                </div>
            </div>
        </Layout>
        <Footer>
            <div v-if="isActiveReplyEmail || isActiveSenderEmail || isActiveDomainEmail" class="d-flex justify-content-center">
                <div class="text-center flex-fill box__button--custom">
                    <button type="button" class="btn btn-common btn-primary" style="min-width: 76px" @click="onBackScreen">
                        <i class="ri-arrow-left-line"></i>{{ $t('managerForm.analytics.btnBackScreen') }}
                    </button>
                </div>
            </div>
            <div v-else class="d-flex justify-content-center">
                <button type="button" class="btn btn-common-footer px-4" @click="onGotoList">
                    <i class="ri-list-check"></i>{{ $t('managerForm.goToListForm') }}
                </button>
            </div>
        </Footer>
    </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Footer from '@/components/Footer/main.vue';
import ReplyEmail from './components/reply/main.vue';
import SenderEmail from './components/sender/main.vue';
import DomainEmail from './components/domain/main.vue';
import { checkPermission } from '@/utils/handlers';

export default {
    name: 'AnalyticsFormList',
    page: {
        title: '管理編集',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        Footer,
        ReplyEmail,
        SenderEmail,
        DomainEmail
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('form.setting_mail')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            isActiveReplyEmail: false,
            isActiveSenderEmail: false,
            isActiveDomainEmail: false
        };
    },
    methods: {
        onOpenSenderEmail() {
            this.isActiveSenderEmail = true;
        },

        onOpenReplyEmail() {
            this.isActiveReplyEmail = true;
        },
        onOpenDomainEmail() {
            this.isActiveDomainEmail = true;
        },

        onBackScreen() {
            this.isActiveReplyEmail = false;
            this.isActiveSenderEmail = false;
            this.isActiveDomainEmail = false;
        },
        onGoToDetail(path, id) {
            this.$router.push({ path: path, query: { id: id } });
        },

        onGotoList() {
            this.$router.push({ name: 'ManagerFormList' });
        }
    }
};
</script>

<style lang="scss" scoped></style>
